import React from 'react';
import { ReactComponent as IconSvg } from '@/images/icons/calendarDetail/import.svg';
const ImportCalendarSvg = () => React.createElement(IconSvg, null);
export default ImportCalendarSvg;
